import React from 'react';
import Plan from "./Plan";

const AddPlan: React.FC = () => {
    return (
        <Plan></Plan>
    );
}

export default AddPlan;